import React, { forwardRef, useEffect, useState } from "react";
import { Typography, Grid } from "@material-ui/core";
import jMoment from "moment-jalaali";
import Num2persian from "num2persian";
import SketchView from "../../components/util/sketch/SketchView";
import Map from "../../components/map/Map";
// import QRCode from "qrcode.react";

const PrintPage = forwardRef((props, ref) => {
  const { valuation = [], parts = [], credits = [], sketchType, sketch } = props;

  const [defaultCoords, setDefaultCoords] = useState([32.63296053018298, 51.3655310869217]);

  useEffect(() => {
    if (valuation?.lat && valuation?.lng) setDefaultCoords([valuation?.lat, valuation?.lng]);
  }, [valuation]);

  const currencyFormat = (num) => {
    return num.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const calc = () => {
    var wholeSum = 0;
    parts.map((part) => {
      wholeSum +=
        parseFloat(part?.amount?.replace(/[^0-9\.]+/g, "")) * parseFloat(part?.value?.replace(/[^0-9\.]+/g, ""));
    });
    // if (valuation.credits_value_role === "value") {
    //   credits.map(credit => {
    //     wholeSum += parseInt(credit.value.replace(/[^0-9\.]+/g, ""));
    //   });
    // } else {
    if (credits?.length && valuation?.credits_sum)
      wholeSum += parseFloat(valuation?.credits_sum?.replace(/[^0-9\.]+/g, ""));

    //   );
    // }
    if (valuation?.enclosure_value) wholeSum += parseFloat(valuation?.enclosure_value?.replace(/[^0-9\.]+/g, ""));

    return Math.floor(wholeSum);
  };

  return (
    <div style={{ margin: 20, border: "2px #000000 solid", borderRadius: 15 }} className='body' ref={ref}>
      {/* <Grid
        container
        spacing={24}
        justify='center'
        alignContent='center'
        alignItems='center'
        style={{
          minHeight: "100vh",
          maxWidth: "100%",
          position: "fixed",
          zIndex: -50000,
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          opacity: "0.4",
        }}
      >
        <img
          style={{}}
          src={process?.env?.REACT_APP_API_URL + "/logo_images/" + valuation?.user?.logo_url}
          onError={(e) => {
            e.target.onerror = null;
            e.target.style.display = "none";
          }}
          height={700}
          width={700}
          alt='logo'
        />
      </Grid> */}
      <style>
        {`
          .body {
            font-family: iranyekan !important;
          }

          body{
            font-family: iranyekan !important;
          }

            @media only print {
              @page { size: a4; }
            
              .body {
                font-family: iranyekan !important;
                direction: rtl;
                margin: 0mm;
                -webkit-print-color-adjust: exact; 
              }
            
              body {
                font-family: iranyekan !important;
                direction: rtl;
                margin: 0mm;
                -webkit-print-color-adjust: exact; 
              }

              * {
                font-family: iranyekan !important;
              }
            
              .round-div {
                border-radius: 15px;
                border: 1.5px solid #757575;
              }
              
              .my-chip {
                border-radius: 15px;
                border: 1px dashed #757575;
                background-color: #FFFFFF00;
                -webkit-print-color-adjust: exact; 
              }
              
              .w3-table-all {
                border-spacing: 0;
                border-radius: 15px;
                border: 1.5px solid #757575;
                font-size: 13px;
                overflow: hidden;
                width: 100%;
                display: table;
                text-align: center;
                margin-bottom: 0 !important;
              }
              .w3-table-all tr:nth-child(odd) {
                background-color: #bdbdbd;
                -webkit-print-color-adjust: exact;
              }
              .w3-table-all tr:nth-child(1) {
                background-color: #9e9e9e;
                -webkit-print-color-adjust: exact;
              }
              .w3-table-all tr:nth-child(even) {
                background-color: #00000000;
                -webkit-print-color-adjust: exact; 
              }
              .w3-table-all td,
              .w3-table-all th {
                border: 1px solid #757575;
                padding: 3px 5px;
                display: table-cell;
                text-align: center;
                vertical-align: top;
                -webkit-print-color-adjust: exact;
              }
            
          }
          `}
      </style>
      <Grid
        container
        direction='column'
        style={{
          paddingTop: 15,
          paddingLeft: 15,
          paddingRight: 15,
          paddingBottom: 10,
        }}
      >
        <>
          <Grid container direction='row'>
            <Grid item xs={3}>
              <Grid container direction='row' alignItems='center' alignContent='center' justify='center'>
                <Typography style={{ fontSize: 13, fontWeight: 500 }}>شماره:</Typography>

                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 800,
                    marginRight: 5,
                  }}
                >
                  {valuation?.full_id?.toPersianDigits()}
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid direction='column' container alignItems='center' alignContent='center' justify='center'>
                <Typography style={{ fontWeight: "bold" }}>(دفتر کارشناسی املاک و ساختمان)</Typography>
                <Typography
                  style={{
                    fontSize: 27,
                    fontWeight: 800,
                    marginTop: 5,
                  }}
                >
                  مشاور املاک {valuation?.user?.work_title?.substring(0, 13)?.toPersianDigits()}
                </Typography>

                <Typography style={{ fontSize: 15, marginTop: 5 }}>گزارش ارزیابی املاک غیر منقول</Typography>
              </Grid>
            </Grid>

            <Grid item xs={3}>
              <Grid container direction='row' alignItems='center' alignContent='center' justify='center'>
                <Typography style={{ fontSize: 13, fontWeight: 500 }}>تاریخ:</Typography>

                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 800,
                    marginRight: 5,
                  }}
                >
                  {valuation?.date && jMoment(valuation?.date).format("jYYYY/jMM/jDD")?.toPersianDigits()}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid container direction='column'>
            <Grid container direction='row' style={{ marginTop: 15 }}>
              <Grid item xs={3}>
                <Grid container direction='row'>
                  <Typography style={{ fontSize: 13, fontWeight: 500 }}>نوع سند:</Typography>

                  <Grid item xs={8}>
                    <Typography
                      style={{
                        fontSize: 13,
                        marginRight: 5,
                        fontWeight: 800,
                      }}
                      noWrap
                    >
                      {valuation?.type?.toPersianDigits()}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={4}>
                <Grid container direction='row'>
                  <Typography style={{ fontSize: 13, fontWeight: 500 }}>صورت ارزیابی از:</Typography>

                  <Grid item xs={7}>
                    <Typography
                      style={{
                        fontSize: 13,
                        marginRight: 5,
                        fontWeight: 800,
                      }}
                      noWrap
                    >
                      {valuation?.from?.toPersianDigits()}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={5}>
                <Grid container direction='row'>
                  <Typography style={{ fontSize: 13, fontWeight: 500 }}>ارائه شده توسط</Typography>

                  <Typography style={{ fontSize: 13, marginRight: 5, fontWeight: 500 }}>
                    {valuation?.gender === "آقا" ? "آقای" : "خانم"}:
                  </Typography>

                  <Grid item xs={7}>
                    <Typography
                      style={{
                        fontSize: 13,
                        marginRight: 5,
                        fontWeight: 800,
                      }}
                      noWrap
                    >
                      {valuation?.first_name?.toPersianDigits()} {valuation?.last_name?.toPersianDigits()}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container direction='row' style={{ marginTop: 7 }}>
              <Grid item xs={3}>
                <Grid container direction='row'>
                  <Typography style={{ fontSize: 13, fontWeight: 500 }}>واقع در:</Typography>

                  <Grid item xs={8}>
                    <Typography
                      style={{
                        fontSize: 13,
                        fontWeight: 800,
                        marginRight: 5,
                      }}
                      noWrap
                    >
                      {valuation?.city?.toPersianDigits()}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={4}>
                <Grid container direction='row'>
                  <Typography style={{ fontSize: 13, fontWeight: 500 }}>با نوع سازه ساختمانی:</Typography>

                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 13,
                        fontWeight: 800,
                        marginRight: 5,
                      }}
                      noWrap
                    >
                      {valuation?.structure_type ? valuation?.structure_type?.toPersianDigits() : "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={4}>
                <Grid container direction='row'>
                  <Typography style={{ fontSize: 13, fontWeight: 500 }}>کد پستی:</Typography>

                  <Grid item xs={9}>
                    <Typography
                      style={{
                        fontSize: 13,
                        fontWeight: 800,
                        marginRight: 5,
                      }}
                      noWrap
                    >
                      {valuation?.postal_code
                        ? (
                            valuation?.postal_code?.slice(0, 5) +
                            "-" +
                            valuation?.postal_code?.slice(5)
                          )?.toPersianDigits()
                        : "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container direction='row' style={{ marginTop: 7 }}>
              <Grid item xs={12}>
                <Grid container direction='row'>
                  <Typography style={{ fontSize: 13, fontWeight: 500 }}>به آدرس:</Typography>
                  <Grid item xs={11}>
                    <Typography
                      style={{
                        fontSize: 13,
                        fontWeight: 800,
                        marginRight: 5,
                      }}
                      noWrap
                    >
                      {valuation?.address?.toPersianDigits()}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container direction='row' style={{ marginTop: 7 }}>
              <Grid item xs={4}>
                <Grid container direction='row'>
                  <Typography style={{ fontSize: 13, fontWeight: 500 }}>تحت پلاک(های) ثبتی:</Typography>

                  <Grid item xs={6}>
                    <Typography
                      style={{
                        fontSize: 13,
                        fontWeight: 800,
                        marginRight: 5,
                      }}
                      noWrap
                    >
                      {valuation?.plate?.toPersianDigits() ?? "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={2}>
                <Grid container direction='row'>
                  <Typography style={{ fontSize: 13, fontWeight: 500 }}>قطعه:</Typography>

                  <Grid item xs={8}>
                    <Typography
                      style={{
                        fontSize: 13,
                        fontWeight: 800,
                        marginRight: 5,
                      }}
                      noWrap
                    >
                      {valuation?.piece?.toPersianDigits() ?? "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={6}>
                <Typography style={{ fontSize: 13, fontWeight: 500 }} noWrap>
                  بازدید و وضع موجود به شرح ذیل مورد ارزیابی قرار گرفت.
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <table className='w3-table-all' style={{ marginTop: 15 }}>
            <tr>
              <th style={{ fontWeight: 800 }} width='16%'>
                شرح عرصه و اعیان
              </th>
              <th style={{ fontWeight: 800 }} width='16%'>
                مساحت
              </th>
              <th style={{ fontWeight: 800 }} width='16%'>
                ارزش هر متر مربع
              </th>
              <th style={{ fontWeight: 800 }} width='18%'>
                ارزش کل
              </th>
              <th style={{ fontWeight: 800 }} width='34%'>
                ملاحظات
              </th>
            </tr>
            {parts?.slice(0, 7)?.map((part, index) => (
              <tr key={index}>
                <td style={{ fontWeight: 800, backgroundColor: "#9e9e9e" }}>{part?.name}</td>
                <td style={{ fontWeight: 500 }}>{part?.amount?.toPersianDigits()}</td>
                <td style={{ fontWeight: 700 }}>
                  {Math.floor(parseInt(part?.value?.replace(/[^0-9\.]+/g, "")))
                    ?.toLocaleString()
                    ?.toPersianDigits()}
                </td>
                <td style={{ fontWeight: 700 }}>
                  {(
                    parseFloat(part?.amount?.replace(/[^0-9\.]+/g, "")) *
                    parseFloat(part?.value?.replace(/[^0-9\.]+/g, ""))
                  )
                    // .toFixed(0)
                    ?.toLocaleString()
                    ?.toPersianDigits()}
                </td>
                {part?.description ? (
                  <td
                    style={{
                      textOverflow: "ellipsis",
                      fontWeight: 500,
                      fontSize: part?.description?.length < 15 ? 13 : 8,
                    }}
                  >
                    {part?.description?.substring(0, 45)?.toPersianDigits()}
                  </td>
                ) : (
                  <td>-----------</td>
                )}
              </tr>
            ))}

            {Array(7 - parts?.slice(0, 7).length)
              .fill(1)
              .map((el, i) => (
                <tr key={i}>
                  <td style={{ backgroundColor: "#9e9e9e" }}>-----------</td>
                  <td>-----------</td>
                  <td>-----------</td>
                  <td>-----------</td>
                  <td>-----------</td>
                </tr>
              ))}

            <tr style={{ backgroundColor: "#FFFFFF00" }}>
              <td
                colSpan={3}
                style={{
                  textAlign: "right",
                  paddingRight: 10,
                  fontWeight: 800,
                }}
              >
                محوطه سازی و جان پناه بام:
              </td>
              {valuation?.enclosure_value ? (
                <td style={{ fontWeight: 700 }}>{currencyFormat(valuation?.enclosure_value)?.toPersianDigits()}</td>
              ) : (
                <td>-----------</td>
              )}
              {valuation?.enclosure_description ? (
                <td
                  style={{
                    textOverflow: "ellipsis",
                    fontWeight: 500,
                    fontSize: valuation?.enclosure_description?.length < 15 ? 13 : 9,
                  }}
                >
                  {valuation?.enclosure_description?.substring(0, 30)?.toPersianDigits()}
                </td>
              ) : (
                <td>-----------</td>
              )}
            </tr>

            <tr style={{ backgroundColor: "#FFFFFF00" }}>
              <td
                colSpan={3}
                style={{
                  textAlign: "right",
                  paddingRight: 10,
                  fontWeight: 800,
                  height: 50,
                  maxHeight: 50,
                }}
              >
                <Grid item xs={12}>
                  <Grid container direction='row' alignItems='center' style={{ padding: 2 }}>
                    <Typography style={{ fontSize: 13, fontWeight: 800 }}>تاسیسات و امتیاز ها:</Typography>
                    {credits?.length &&
                      credits?.slice(0, 8).map((credit) => (
                        <Grid
                          item
                          className='my-chip'
                          style={{
                            paddingLeft: 4,
                            paddingRight: 4,
                            paddingTop: 2,
                            paddingBottom: 2,
                            marginTop: 3,
                            marginRight: 5,
                          }}
                        >
                          <Grid container direction='row'>
                            <Typography style={{ fontSize: 10, fontWeight: 500 }}>
                              {credit?.name?.toPersianDigits()}:
                            </Typography>

                            <Typography
                              style={{
                                fontSize: 10,
                                marginRight: 5,
                                fontWeight: 500,
                              }}
                            >
                              {credit?.amount?.toPersianDigits()}
                            </Typography>
                            {credit?.description && (
                              <Typography
                                style={{
                                  fontSize: 10,
                                  marginRight: 5,
                                  fontWeight: 500,
                                }}
                              >
                                {credit?.description?.toPersianDigits()}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      ))}
                  </Grid>
                </Grid>
              </td>
              {valuation?.credits_sum ? (
                <td style={{ fontWeight: 700 }}>{currencyFormat(valuation?.credits_sum)?.toPersianDigits()}</td>
              ) : (
                <td>-----------</td>
              )}
              {valuation?.credits_description ? (
                <td
                  style={{
                    fontWeight: 500,
                    textOverflow: "ellipsis",
                    fontSize: valuation?.credits_description?.length < 15 ? 13 : 9,
                  }}
                >
                  {valuation?.credits_description?.substring(0, 110)?.toPersianDigits()}
                </td>
              ) : (
                <td>-----------</td>
              )}
            </tr>
          </table>

          <Grid item xs={12}>
            <Grid
              item
              className='round-div'
              style={{
                marginTop: 5,
                paddingTop: 5,
                paddingLeft: 10,
                paddingRight: 10,
                paddingBottom: 5,
              }}
            >
              <Grid container direction='row'>
                <Typography style={{ fontSize: 14, fontWeight: 500 }}>جمع کل به عدد:</Typography>

                <Typography
                  style={{
                    fontSize: 14,
                    marginRight: 5,
                    fontWeight: 800,
                  }}
                >
                  {calc().toLocaleString()?.toPersianDigits() + " تومان"}
                </Typography>
              </Grid>

              <Grid container direction='row' style={{ marginTop: 5 }}>
                <Typography style={{ fontSize: 14, fontWeight: 500 }}>جمع کل به حروف:</Typography>

                <Typography
                  style={{
                    fontSize: 14,
                    marginRight: 5,
                    fontWeight: 800,
                  }}
                >
                  {Num2persian(parseInt(calc())) + " تومان"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid container direction='row'>
            <Grid item xs={7}>
              <Grid
                container
                className='round-div'
                style={{
                  paddingRight: 10,
                  paddingLeft: 10,
                  paddingTop: 5,
                  paddingBottom: 5,
                  marginTop: 5,
                }}
              >
                <Grid item xs={12}>
                  <Typography style={{ fontWeight: 500 }}>کروکی محل</Typography>
                  <Typography style={{ flexGrow: 1 }} align='center'>
                    شمال
                  </Typography>
                </Grid>
                {sketchType === "map" ? (
                  <div
                    style={{
                      height: 250,
                      width: 400,
                      overflow: "hidden",
                      filter: "saturate(500%) grayscale(2) brightness(70%) contrast(200%)",
                    }}
                  >
                    <Map defaultCoords={defaultCoords} disabled print />
                  </div>
                ) : valuation?.sketch_url ? (
                  <Grid item xs={12} style={{ height: 320, width: 320 }}>
                    <SketchView data={{ sketch: sketch }} />
                  </Grid>
                ) : (
                  <Grid item xs={12} style={{ height: 390 }}>
                    <img
                      src={process.env.REACT_APP_API_URL + "/crookie_images/" + valuation?.crookie_url}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = "none";
                      }}
                      style={{
                        margin: 5,
                        borderRadius: 15,
                        border: "1px #757575 dashed",
                        height: 340,
                        width: 340,
                      }}
                      alt='crookie'
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Grid item xs={5}>
              <Grid
                item
                className='round-div'
                style={{
                  padding: 15,
                  marginTop: 5,
                  marginRight: 5,
                  height: sketchType === "map" ? 310 : 380,
                }}
              >
                <Typography style={{ fontSize: 12, fontWeight: 700 }}>نکات قابل توجه:</Typography>

                <Grid container direction='column' style={{ marginRight: 10, marginTop: 10 }}>
                  <Typography style={{ fontSize: 10 }}>
                    ۱-واحد اندازه گیری به متر و واحد ارزش‌ها به تومان میباشد.
                  </Typography>

                  <Typography style={{ fontSize: 10 }}>۲−متراژ و ارقام کنترل گردد بخصوص هنگام معامله.</Typography>

                  <Typography style={{ fontSize: 10 }}>۳-ارزیابی بر اساس وضع موجود میباشد.</Typography>

                  <Typography style={{ fontSize: 10 }}>۴-صورت ارزیابی فوق بدون خط خوردگی معتبر می باشد.</Typography>

                  <Typography style={{ fontSize: 10 }}>۵-در صورت هرگونه ابهام با شماره های ذیل تماس بگیرید.</Typography>

                  <Grid container direction='column' justify='center' alignContent='center' alignItems='center'>
                    <Typography style={{ fontSize: 14, marginTop: 10, fontWeight: 700 }}>
                      ارزیابی فوق به نظر اینجانب رسید.
                    </Typography>

                    <Typography style={{ fontSize: 13, marginTop: 50, fontWeight: 500 }}>
                      ارزیاب املاک و ساختمان
                    </Typography>

                    <Typography style={{ fontSize: 12, fontWeight: 800 }}>
                      {valuation?.user?.first_name?.toPersianDigits() +
                        " " +
                        valuation?.user?.last_name?.toPersianDigits()}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid
              container
              direction='row'
              justify='center'
              alignContent='center'
              alignItems='center'
              style={{ marginTop: 5 }}
            >
              <Typography style={{ fontSize: 10, fontWeight: "bold" }}>مشاور املاک و دفتر کارشناسی</Typography>

              <Typography style={{ fontSize: 10, marginRight: 5, fontWeight: "bold" }}>
                {valuation?.user?.work_title?.toPersianDigits()}:
              </Typography>

              <Typography style={{ fontSize: 10, marginRight: 5, fontWeight: "bold" }}>
                {valuation?.user?.work_address?.toPersianDigits()}.
              </Typography>

              <Typography style={{ fontSize: 10, marginRight: 5, fontWeight: "bold" }}>تلفن:</Typography>

              <Typography style={{ fontSize: 10, marginRight: 5, fontWeight: "bold" }}>
                {valuation?.user?.work_number?.toPersianDigits()}
              </Typography>

              <Typography
                style={{
                  fontSize: 10,
                  marginRight: 10,
                  fontWeight: "bold",
                }}
              >
                تلفن همراه:
              </Typography>

              <Typography style={{ fontSize: 10, marginRight: 5, fontWeight: "bold" }}>
                {valuation?.user?.phone_number?.toPersianDigits()}
              </Typography>

              <Typography
                style={{
                  fontSize: 10,
                  marginRight: 10,
                  fontWeight: "bold",
                }}
              >
                {valuation?.user?.first_name?.toPersianDigits() + " " + valuation?.user?.last_name?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>
        </>
      </Grid>
    </div>
  );
});

export default PrintPage;
